<template>
  <v-container
    v-if="
      connecte &&
        this.$store.getters.currentUser.clientData.indCommandeTPAutorise == true
    "
  >
    <v-row class="px-3">
      <v-text-field
        v-model="keywordRecherche"
        label="Rechercher des produits"
        class="font-weight-bold"
        clearable
        @keyup.enter="rechercherProduit()"
      />
      <v-btn icon class="secondary">
        <v-icon color="white" @click="rechercherProduit()">search</v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n'
import { eventsHub } from '../main.ts'

export default {
  name: 'SearchBar',

  data() {
    return {
      keywordRecherche: null
    }
  },

  computed: {
    connecte: function() {
      console.log('connecte=' + this.$store.getters.estAuthentifie)
      return this.$store.getters.estAuthentifie
    }
  },

  methods: {
    rechercherProduit() {
      this.$store.commit('mRechercherProduit', this.keywordRecherche)
      this.$store.dispatch('rechercheProduit')
      this.keywordRecherche = null
    }
  }
}
</script>
